import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import authService from '../services/authService';
import OtpInput from '../components/ForgotPassword/Otp';
import Toast from '../components/Toast';
import OnboardingTemplate from '../components/OnboardingTemplate';
import { FormContent } from '../components/Login/Login.styles';
import Button from '../components/Button';
function VerifyOtp() {
  const [email, setEmail] = useState('');
  const [otpValue, setOtpValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [OTPError, setOTPError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const localMail = localStorage.getItem('otp_email');
    setEmail(localMail);
  }, []);
  async function handelVerifyOtp() {
    const otp_code = otpValue.join('');

    if (otp_code.length < 4) {
      setOTPError(true);
      return;
    }
    setLoading(true);
    const payload = {
      email: email,
      otp: otp_code,
    };
    try {
      const resp = await authService.verify(payload);
      if (resp.success) {
        Toast({
          type: 'success',
          message: resp.message,
        });
        navigate('/successful', { state: { from: 'signup' } });
        setLoading(false);
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
      setLoading(false);
    }
  }
  async function handelResend() {
    try {
      const resp = await authService.sendOtp({ email: email });
      if (resp.message) {
        Toast({
          type: 'info',
          message: resp.message,
        });
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
    }
  }
  return (
    <Layout showTemplate={false}>
      <OnboardingTemplate>
        <FormContent>
          <div className="text-content">
            <div className="text-wrapper">
              <div className="heading-text">
                <h1>Verify Your Account!</h1>
                <p>
                  We’ve sent an 4-digit otp to your mail <br />
                  <i>{email}</i>
                </p>
              </div>
              <OtpInput
                numInputs={4}
                setOtpValue={value => setOtpValue(value)}
                handleResentOtp={() => handelResend()}
                OTPError={OTPError}
                setOTPError={setOTPError}
              />

              <Button width="100%" delayAnimation loader={loading} onClick={handelVerifyOtp}>
                Verify OTP!
              </Button>
            </div>
          </div>
        </FormContent>
      </OnboardingTemplate>
    </Layout>
  );
}

export default VerifyOtp;
